import {ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import {SectionTemplateI} from "../../../../builder-v2.interface";
import {CanvasPageInteractionsService} from "../../../../services/canvas-page-interactions.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {animate, style, transition, trigger} from "@angular/animations";

@Component({
    selector: 'db-canvas-page-actions',
    templateUrl: './canvas-page-actions.component.html',
    styleUrl: './canvas-page-actions.component.scss',
    animations: [
        // trigger('slideInOut', [
        //   state('true', style({transform: 'translateX(0)', opacity: 1})),
        //   state('false', style({transform: 'translateX(100%)', opacity: 0})),
        //   transition('false => true', [
        //     style({transform: 'translateX(100%)', opacity: 0}),
        //     animate('0.2s ease-out')
        //   ]),
        //   transition('true => false', [
        //     animate('0.2s ease-out', style({transform: 'translateX(100%)', opacity: 0}))
        //   ])
        // ])
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate('200ms ease-in', style({ transform: 'translateX(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                animate('200ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class CanvasPageActionsComponent implements OnInit {
  @Input() sectionTemplates: SectionTemplateI[] = [];
  pageInteractionsService = inject(CanvasPageInteractionsService);
  openedAction: 'addPage' | 'addSection' | 'editSection' = null;
  pendingAction: 'addPage' | 'addSection' | 'editSection' = null;
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  timeout = null;
  nextAction = null;

  ngOnInit() {
    this._listenAddSection();
    this._listenEditSection();
    this._listenAddPage();
  }


  setAction(action: 'addPage' | 'addSection' | 'editSection' | null) {
    this.nextAction = action;
    if (this.timeout) {
      return;
    }
    if (this.openedAction) {
      this.openedAction = null;
      this.timeout = true;

      setTimeout(() => {
        this.openedAction = this.nextAction;
        this._cdr.detectChanges();
        this.timeout = null;
      }, 200);
    } else {
      this.openedAction = this.nextAction;
    }
  }


  closeAddSection() {
    this.pageInteractionsService.openAddSection.next(null);
    this.setAction(null);
  }

  closeEditSection() {
    this.pageInteractionsService.openSectionEdit.next(null);
    this.setAction(null);
  }

  closeAddPage() {
    this.pageInteractionsService.openAddPage.next(null);
    this.setAction(null);
  }

  private _listenAddSection() {
    this.pageInteractionsService.openAddSection
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data === null && this.openedAction === 'addSection') {
          this.setAction(null);
        }
        if (data?.pageId && this.openedAction !== 'addSection') {
          this.setAction('addSection');
        }
      });
  }

  private _listenEditSection() {
    this.pageInteractionsService.openSectionEdit
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data === null && this.openedAction === 'editSection') {
          this.setAction(null);
        }
        if (data?.pageId) {
          this.setAction('editSection');
        }
      });
  }

  private _listenAddPage() {
    this.pageInteractionsService.openAddPage
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data === null && this.openedAction === 'addPage') {
          this.setAction(null);
        }
        if (data?.pageId) {
          this.setAction('addPage');
        }
      });
  }
}
